import React, { useState, useCallback } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = useCallback(() => {
    setIsMenuOpen(prev => !prev);
  }, []);

  const scrollToSection = useCallback((sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      requestAnimationFrame(() => {
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      });
    }
    setIsMenuOpen(false);
  }, []);

  return (
    <header className="header">
      <div className="logo">
        <h1 className="text-logo">Gardenia Landscaping LLC.</h1>
      </div>
      
      <button 
        className="mobile-menu-button" 
        onClick={toggleMenu} 
        aria-label="Toggle menu"
        aria-expanded={isMenuOpen}
      >
        <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}></span>
      </button>

      <nav 
        className={`nav-menu ${isMenuOpen ? 'open' : ''}`}
        aria-hidden={!isMenuOpen}
      >
        <ul>
          {[
            ['home', 'Home'],
            ['services', 'Services'],
            ['gallery', 'Gallery'],
            ['about', 'About'],
            ['contact', 'Contact']
          ].map(([id, label]) => (
            <li key={id}>
              <button 
                onClick={() => scrollToSection(id)} 
                className="nav-button"
                aria-label={`Scroll to ${label} section`}
              >
                {label}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header; 